import React from 'react';

interface FaqItem {
  id: string;
  question: string;
  answerHtml: string;
}

interface FaqJsonLdProps {
  items: FaqItem[];
}

/**
 * FAQ JSON-LD Schema component for SEO
 * Injects structured data for FAQ pages
 */
export default function FaqJsonLd({ items }: FaqJsonLdProps) {
  if (!items || items.length === 0) {
    return null;
  }

  // Convert HTML answers to plain text for schema
  const stripHtml = (html: string): string => {
    if (typeof window === 'undefined') {
      // Server-side: basic HTML stripping
      return html.replace(/<[^>]*>/g, '');
    }
    
    // Client-side: use DOM parser
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || '';
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: stripHtml(item.answerHtml)
      }
    }))
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(faqSchema)
      }}
    />
  );
}